import styled from 'styled-components';
import {SectionContainer, SectionTitle} from './Layout';
import {useTranslation} from 'react-i18next';

type Props = {
  remainingParticipants: HRProject['remainingParticipants'];
  totalExperience: HRProject['totalExperience'];
  totalExperienceCompleted: HRProject['totalExperienceCompleted'];
};

const SectionGeneralInfo = ({
  remainingParticipants,
  totalExperience,
  totalExperienceCompleted,
}: Props) => {
  const {t} = useTranslation();

  return (
    <Background>
      <SectionContainer>
        <SectionTitle>{t('dashboard.general-info')}</SectionTitle>
        <Row>
          <Cell>
            <Box>{t('dashboard.credits')}</Box>
            <BoxBold>{remainingParticipants}</BoxBold>
          </Cell>
          <Cell>
            <Box>{t('dashboard.reports-pending')}</Box>
            <BoxBold>{totalExperience - totalExperienceCompleted}</BoxBold>
          </Cell>
          <Cell>
            <Box>{t('dashboard.reports-created')}</Box>
            <BoxBold>{totalExperienceCompleted}</BoxBold>
          </Cell>
        </Row>
      </SectionContainer>
    </Background>
  );
};

export default SectionGeneralInfo;

const Background = styled.section`
  background-color: ${(p) => p.theme.colors.orange100};
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 24px;
  row-gap: 16px;
  border-radius: 4px;
  background-color: white;
  padding: 20px 24px;
  box-shadow: 0 10px 30px rgba(254, 103, 68, 0.08);
`;

const Cell = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Box = styled.div`
  background-color: ${(p) => p.theme.colors.violet100};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  border-radius: 4px;
  font-family: 'Bossa', sans-serif;
`;

const BoxBold = styled(Box)`
  background-color: ${(p) => p.theme.colors.violet200};
  font-weight: 700;
  color: ${(p) => p.theme.colors.violet500};
`;
